import React, { useState, useEffect } from 'react'
import ReactGoogleMap from '../../../extensions/ClickableMap/ReactGoogleMap'
import PinSvg1 from './Resources/googlePin1.svg'
import PinSvg2 from './Resources/googlePin2.svg'
import PinSvg3 from './Resources/googlePin3.svg'
import PinSvg4 from './Resources/googlePin4.svg'
import PinSvg5 from './Resources/googlePin5.svg'
import PinSvg6 from './Resources/googlePin6.svg'
import PinSvg7 from './Resources/googlePin7.svg'
import PinSvg8 from './Resources/googlePin8.svg'
import PinSvg9 from './Resources/googlePin9.svg'
import PinSvg10 from './Resources/googlePin10.svg'
import PinSvg11 from './Resources/googlePin11.svg'
import PinSvg12 from './Resources/googlePin12.svg'
import PinSvg13 from './Resources/googlePin13.svg'
import PinSvg14 from './Resources/googlePin14.svg'
import PinSvg15 from './Resources/googlePin15.svg'
import { useLocale } from '../../../extensions/Locale/useLocale'
import POconstants from '../../../Utils/POconstants'
import constants from '../../../Utils/constants'

const SEEN_THING_PINS: { [K in DidYouSeeThis.ThingsToSee]: string } = {
    periska: PinSvg1,
    obicnaPeriska: PinSvg4,
    kirnja: PinSvg2,
    jezinac: PinSvg6,
    zupka: PinSvg14,
    truba: PinSvg12,
    zlatica: PinSvg3,
    vatrenjaca: PinSvg7,
    drozd: PinSvg8,
    konjic: PinSvg9,
    hlap: PinSvg10,
    rak: PinSvg11,
    gerardia: PinSvg5,
    roznjaca: PinSvg13,
    posidonija: PinSvg15,
}

const useReportMap: Client.ReportMap.Service = () => {
    const { currentLang, lang } = useLocale<Locale.Keys>()
    if (!process.env.REACT_APP_GOOGLE_MAPS_API_KEY) throw new Error("can't read google maps api key from env") //DEV
    const BASE_URL = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`
    const [googleMapUrl, googleMapUrl_set] = useState<string>(BASE_URL + '&language=' + currentLang)
    const [markerPosition, markerPoisiton_set] = useState<{ lat: number; lng: number }>()
    const [reports, reports_set] = useState<Server.ReportSighting.SheetEntry[]>([])
    const [filteredReports, filteredReports_set] = useState<Server.ReportSighting.SheetEntry[]>([])
    const [filters, filters_set] = useState<Client.ReportMap.Service.Filters>({})
    useEffect(() => {
        filteredReports_set(
            reports.filter((report) => {
                let passFilter = true
                if (filters?.maxDate && getDateFromString(report.date) > filters.maxDate) passFilter = false
                else if (filters?.minDate && getDateFromString(report.date) < filters.minDate) passFilter = false
                else if (filters?.name && !report.reportedBy.toLocaleLowerCase().includes(filters.name.toLocaleLowerCase()))
                    passFilter = false
                else if (
                    filters?.seenThing &&
                    Object.values(filters.seenThing).some((value) => value === true) &&
                    !(filters.seenThing as any)[constants.getSeenThingName(report.seenThing) || report.seenThing]
                )
                    passFilter = false
                else if (filters?.email && !report.email.includes(filters.email)) passFilter = false
                return passFilter
            })
        )
    }, [filters, reports])
    useEffect(() => {
        googleMapUrl_set(BASE_URL + '&language=' + currentLang)
        const loadData = async () => {
            try {
                let response = await fetch(getReportsUrl(), {
                    method: 'GET',
                    credentials: 'include',
                    mode: 'cors',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                })
                if (!response.ok) throw new Error('Error fetching reports: ' + response.status)
                const result = await response.json()
                reports_set(result)
            } catch (error) {
                console.log('===error loading reports===', new Date(), error)
                reports_set([])
            }
        }
        loadData()
    }, [currentLang])
    return {
        mapComponent: (
            <ReactGoogleMap
                googleMapURL={googleMapUrl}
                defaultCenter={{ lat: 43.163254, lng: 16.368428 }}
                markers={filteredReports.map((report) => {
                    const seenThingName = constants.getSeenThingName(report.seenThing)
                    return {
                        position: report.position,
                        otherProps: {
                            icon: { url: seenThingName ? SEEN_THING_PINS[seenThingName] : PinSvg1 },
                        },
                        info: {
                            title: seenThingName ? (lang as any)[seenThingName]?.title : report.seenThing,
                            date: report.date,
                            reportedBy: report.reportedBy,
                            email: report.email,
                        },
                    }
                })}
                containerElement={<div style={{ width: '1000px', maxWidth: '90vw', height: '400px', margin: '0.5rem 0 1rem' }}></div>}
            />
        ),
        filteredReports,
        filters_set,
        filters,
        resetCoordinates: () => markerPoisiton_set(undefined),
        coordinates: markerPosition ? { longitude: markerPosition.lng, latitude: markerPosition.lat } : undefined,
    }
}

export default useReportMap

const getReportsUrl = () =>
    process.env.NODE_ENV === 'development' ? 'http://localhost:8221' + POconstants.APIRoutes.getReports : POconstants.APIRoutes.getReports

const getDateFromString = (dateString: string) => {
    const day = Number(dateString.substr(0, 2))
    const indexOfFirstDash = dateString.indexOf('-')
    const restOfString = dateString.slice(indexOfFirstDash + 1)
    const indexOfNextDash = restOfString.indexOf('-')
    const month = Number(restOfString.slice(0, indexOfNextDash))
    const year = Number(restOfString.substr(indexOfNextDash + 1, 4))
    const newDate = new Date()
    newDate.setDate(day)
    newDate.setFullYear(year)
    newDate.setMonth(month - 1)
    return newDate
}
